module.exports = __webpack_public_path__ + "static/media/trailcotton.3a7eb634.png";